import api from "../api";
import { IPaginateResponse } from "@/interfaces/Fetch";
import {
  Team,
  TeamFilters,
  TeamFormSend,
  TeamUpdateFormSend,
} from "@/interfaces/Team";

export const teamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeams: build.query<IPaginateResponse<Team>, TeamFilters>({
      query: (params) => ({
        url: "/teams",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: "Teams" as const, id })),
              { type: "Teams", id: "LIST" },
            ]
          : [],
    }),
    getTeam: build.query<Team, string>({
      query: (id) => `/teams/${id}`,
      providesTags: (_team, _err, id) => [{ type: "Teams", id }],
    }),
    storeTeam: build.mutation<Team, TeamFormSend>({
      query: (body) => ({
        url: "/teams",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Teams", id: "LIST" },
      ],
    }),
    updateTeam: build.mutation<Team, [string, TeamUpdateFormSend]>({
      query: ([id, body]) => ({
        url: `/teams/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_team, _err, [id]) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Teams", id },
        { type: "Teams", id: "LIST" },
      ],
    }),
    destroyTeam: build.mutation<void, string>({
      query: (id) => ({
        url: `/teams/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Teams", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetTeamsQuery,
  useLazyGetTeamsQuery,
  useGetTeamQuery,
  useStoreTeamMutation,
  useUpdateTeamMutation,
  useDestroyTeamMutation,
} = teamsApi;
